import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setGoalType } from "../../../../../redux/actions/overview";
import { Dropdown } from "react-bootstrap";
import DropdownMenu from "../../../../universal/dropdown-menu";

import "./style.scss";
import { Title } from "../../../../library/title";

const Index = () => {
  const dispatch = useDispatch();

  const activeCompany = useSelector(
    (state) => state.activeCompany && state.activeCompany.activeCompany
  );
  const selectedOption = useSelector((state) => state.overview.fetchGoals.type);
  const userLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const loading = useSelector((state) => state.overview.fetchGoals.loading);

  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);

  const selectFilter = (type) => {
    dispatch(setGoalType(type));
  };

  const renderFilterDisplay = () => {
    if (!loading) {
      if (selectedCompany) {
        switch (selectedOption) {
          case "sales":
            return "Salg";
          case "clients":
            return "Kunder";
          case "deliveries":
            return "Leveranser";
        }
      } else {
        return "Ingen";
      }
    } else {
      return "Laster";
    }
  };

  const renderToggle = () => {
    return (
      <Dropdown.Toggle
        onClick={() => setTypeDropdownOpen(!typeDropdownOpen)}
        disabled={loading || (!userLoading && !selectedCompany) ? true : false}
        id="dropdown-filter"
      >
        {renderFilterDisplay()} <i class="fad arrow fa-angle-down"></i>
      </Dropdown.Toggle>
    );
  };

  const selectOptions = [
    {
      title: "Salg",
      key: "sales",
      active: renderFilterDisplay() === "Salg",
      action: () => selectFilter("sales"),
    },
    {
      title: "Kunder",
      key: "clients",
      active: renderFilterDisplay() === "Kunder",
      action: () => selectFilter("clients"),
    },
    {
      title: "Leveranser",
      key: "deliveries",
      active: renderFilterDisplay() === "Leveranser",
      action: () => selectFilter("deliveries"),
    },
  ];

  return (
    <Row className="dashboard-goals-upper-row">
      <Col className="text-left title-col my-auto">
        <Title size="regular">Mål</Title>
      </Col>
      <Col className="text-right button-col my-auto">
        <DropdownMenu
          size="medium"
          content="regular"
          type="title"
          color="inverse-blue"
          toggle={renderToggle()}
          title="Velg type"
          options={selectOptions}
          open={typeDropdownOpen}
          setOpen={setTypeDropdownOpen}
        />
      </Col>
    </Row>
  );
};

export default Index;
